import { NgModule } from '@angular/core';
import { NewsletterComponent } from './newsletter.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [NewsletterComponent],
  imports: [SharedModule],
})
export class NewsletterModule {}
